import { getApexDomain } from './get-apex-domain';

const BASE_URL_HOSTNAME = getApexDomain(new URL(import.meta.env.VITE_BASE_URL).hostname);

export const replaceApexDomainForCurrentHost = (host: string) => {
  const currentApexDomain = getApexDomain(window.location.hostname);

  if (currentApexDomain === 'localhost') {
    return host;
  }

  return host.replace(BASE_URL_HOSTNAME, currentApexDomain);
};
